// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client/" + "client/index" + "." + "20079aed" + ".css";
};